(function () {
  'use strict';

  /* ── Gallery ───────────────────────────────────────────────────────────── */

  var slides  = Array.from(document.querySelectorAll('.product-gallery__slide'));
  var thumbs  = Array.from(document.querySelectorAll('.product-gallery__thumb'));
  var counter = document.querySelector('.product-gallery__counter');
  var current = 0;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    thumbs[current] && thumbs[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    thumbs[current] && thumbs[current].classList.add('is-active');
    if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { goTo(i); });
  });

  var prevBtn = document.querySelector('.product-gallery__arrow--prev');
  var nextBtn = document.querySelector('.product-gallery__arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  /* Touch swipe on mobile */
  var touchStartX = 0;
  var mainEl = document.querySelector('.product-gallery__main');
  if (mainEl) {
    mainEl.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    mainEl.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  /* ── Variant / option selection ────────────────────────────────────────── */

  var variantData  = JSON.parse(document.getElementById('product-variants-json').textContent || '[]');
  var selectedOpts = {};
  var variantInput = document.getElementById('product-variant-id');

  /* Seed selectedOpts from the pre-selected variant */
  var preSelected = variantData.find(function (v) { return v.available; }) || variantData[0];
  if (preSelected) {
    preSelected.options.forEach(function (val, i) {
      selectedOpts['option' + (i + 1)] = val;
    });
  }

  function findVariant() {
    return variantData.find(function (v) {
      return v.options.every(function (val, i) {
        return val === selectedOpts['option' + (i + 1)];
      });
    }) || null;
  }

  function updateUI(variant) {
    var priceEl   = document.getElementById('product-price');
    var compareEl = document.getElementById('product-compare-price');
    var atcBtn    = document.getElementById('product-atc');
    var atcNote   = document.getElementById('product-atc-note');

    if (!variant) {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
      return;
    }

    variantInput && (variantInput.value = variant.id);

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('is-sold-out');
        atcBtn.textContent = 'Add to Cart';
        if (atcNote) atcNote.textContent = 'Free shipping on orders over $100';
      } else {
        atcBtn.disabled = true;
        atcBtn.classList.add('is-sold-out');
        atcBtn.textContent = 'Sold Out';
        if (atcNote) atcNote.textContent = '';
      }
    }

    /* Update unavailable option buttons */
    document.querySelectorAll('.product-info__option-btns').forEach(function (group, groupIdx) {
      var optKey = 'option' + (groupIdx + 1);
      group.querySelectorAll('.option-btn').forEach(function (btn) {
        var testOpts = Object.assign({}, selectedOpts);
        testOpts[optKey] = btn.dataset.value;
        var testVariant = variantData.find(function (v) {
          return v.options.every(function (val, i) { return val === testOpts['option' + (i + 1)]; });
        });
        btn.classList.toggle('is-unavailable', !testVariant || !testVariant.available);
      });
    });
  }

  document.querySelectorAll('.option-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group    = btn.closest('.product-info__option-btns');
      var groupIdx = Array.from(document.querySelectorAll('.product-info__option-btns')).indexOf(group);
      var optKey   = 'option' + (groupIdx + 1);

      group.querySelectorAll('.option-btn').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selectedOpts[optKey] = btn.dataset.value;
      updateUI(findVariant());
    });
  });

  /* Run once on load */
  updateUI(preSelected);

  /* ── Quantity ──────────────────────────────────────────────────────────── */

  var qtyInput = document.getElementById('product-qty');
  document.querySelectorAll('.product-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = parseInt(btn.dataset.delta, 10);
      var val   = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val + delta);
    });
  });

  /* ── Add to Cart ───────────────────────────────────────────────────────── */

  /* ── Buy Now ───────────────────────────────────────────────────────────── */

  var buyNowBtn = document.getElementById('product-buy-now');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var id  = parseInt(variantInput.value, 10);
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10);
      if (!id) return;

      buyNowBtn.disabled = true;
      buyNowBtn.textContent = '—';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty }),
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = 'Checkout Now';
        });
    });
  }

  var atcForm = document.getElementById('product-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('product-atc');
      if (!btn || btn.disabled) return;

      var id  = parseInt(variantInput.value, 10);
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10);
      if (!id) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '—';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty }),
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          btn.textContent = 'Added';
          syncCartCount();
          showToast('Added to cart');
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  }

  /* ── Cart count ────────────────────────────────────────────────────────── */

  function syncCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-cart-count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        });
      })
      .catch(function () {});
  }

  /* ── Toast ─────────────────────────────────────────────────────────────── */

  var toastTimer;
  function showToast(msg) {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
  }

  /* ── Size guide modal ──────────────────────────────────────────────────── */

  var overlay   = document.getElementById('size-guide-overlay');
  var openBtn   = document.getElementById('size-guide-open');
  var closeBtn  = document.getElementById('size-guide-close');

  function openModal()  { overlay && overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeModal() { overlay && overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

  if (openBtn)  openBtn.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (overlay)  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* ── Recommendations ───────────────────────────────────────────────────── */

  var recsEl = document.getElementById('product-recs');
  if (recsEl) {
    var productId = recsEl.dataset.productId;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || data.products.length === 0) {
          recsEl.closest('.product-recommendations') && recsEl.closest('.product-recommendations').remove();
          return;
        }
        var html = data.products.map(function (p) {
          var img  = p.images[0] ? '<img src="' + p.images[0].src + '" alt="' + p.title + '" loading="lazy">' : '<div class="product-card__placeholder"><span>DG</span></div>';
          var img2 = p.images[1] ? '<img class="product-card__img product-card__img--secondary" src="' + p.images[1].src + '" alt="' + p.title + '" loading="lazy">' : '';
          var price = formatMoney(p.variants[0].price);
          return [
            '<div class="product-card">',
            '  <a href="' + p.url + '" class="product-card__media-link">',
            '    <div class="product-card__media">',
            '      <img class="product-card__img product-card__img--primary" src="' + (p.images[0] ? p.images[0].src : '') + '" alt="' + p.title + '" loading="lazy">',
            img2,
            '    </div>',
            '  </a>',
            '  <div class="product-card__info">',
            '    <a href="' + p.url + '" class="product-card__title">' + p.title + '</a>',
            '    <span class="product-card__price">' + price + '</span>',
            '  </div>',
            '</div>',
          ].join('');
        }).join('');
        recsEl.innerHTML = html;
      })
      .catch(function () {
        recsEl.closest('.product-recommendations') && recsEl.closest('.product-recommendations').remove();
      });
  }

  /* ── Accordions ────────────────────────────────────────────────────────── */

  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    var body = trigger.nextElementSibling;

    /* Set initial state for any open by default */
    if (trigger.getAttribute('aria-expanded') === 'true') {
      body.style.display = 'block';
    }

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        trigger.setAttribute('aria-expanded', 'false');
        body.style.height = body.scrollHeight + 'px';
        requestAnimationFrame(function () {
          body.style.transition = 'height 0.35s cubic-bezier(0.76, 0, 0.24, 1)';
          body.style.height = '0';
        });
        body.addEventListener('transitionend', function handler() {
          body.style.display = 'none';
          body.style.height = '';
          body.style.transition = '';
          body.removeEventListener('transitionend', handler);
        });
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        body.style.display = 'block';
        body.style.height = '0';
        body.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          body.style.transition = 'height 0.35s cubic-bezier(0.22, 1, 0.36, 1)';
          body.style.height = body.scrollHeight + 'px';
        });
        body.addEventListener('transitionend', function handler() {
          body.style.height = '';
          body.style.overflow = '';
          body.style.transition = '';
          body.removeEventListener('transitionend', handler);
        });
      }
    });
  });

  /* ── Money formatter ───────────────────────────────────────────────────── */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

})();
